import styled from "styled-components";

import { mobileAndTablet } from "_/style/media";

import heroImage from "./hero-parts.webp";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px;
  background:
    linear-gradient(
      180deg,
      rgba(11, 13, 15, 0) 0%,
      rgba(11, 13, 15, 0.1) 70%,
      rgba(11, 13, 15, 0.6) 100%
    ),
    url("${heroImage}") center / cover no-repeat;
  background-color: ${(p) => p.theme.background.primary};
`;

export const Card = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 56px 52px 66px;
  border: 1px solid ${(p) => p.theme.border.default};
  border-radius: 6px;
  background: ${(p) => p.theme.background.secondary};
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);

  ${mobileAndTablet`
    padding: 32px 24px;
  `}
`;

export const Brand = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
`;
